(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
    if (!openDetails.length) return;

    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    const target = event.target;

    for (let i = 0; i < openDetails.length; i++) {
      const element = openDetails[i];
      const attr = element.getAttribute('data-auto-close-details');
      if (attr && attr.includes(closingOn) && !(target instanceof Node && element.contains(target))) {
        element.removeAttribute('open');
      }
    }
  });
})();
